<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="store_popup_box purchase purchase_success modal_cont" id="store_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_successfull_purchase }}</h1>
        <img src="static/images/store/photo-success.png" class="purchase_img">
        <h2>{{ getTranslations.home_modals_confirm_purchase_well_done }}</h2>
        <p>{{ getTranslations.home_modals_confirm_purchase_successfull_games_were_unlocked }}
          {{getBundleData.numberOfCoins ? getBundleData.numberOfCoins + ' ' + getTranslations.home_modals_confirm_purchase_successfull_games:'' }}
          {{getBundleData.numberOfCoins && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :''}}
          {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_successfull_points : '' }}
          <br> {{ getTranslations.home_modals_confirm_purchase_successfull_do_you_want_to_start_new_game }}</p>
        <button type="" @click.prevent="playMethod">
          {{ getTranslations.home_modals_confirm_purchase_successfull_new_game }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapMutations } from 'vuex';
import modals from '@/common/modals';
import NewGameModal from '../pregame/NewGameModal';
import PreGameModal from '../pregame/PreGameModal';

export default {
  name: 'confirmPurchaseSuccessful',
  components: { NewGameModal, PreGameModal },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    showModal() {
      modals.showHideModalInStore(this);
    },
    playMethod() {
      this.storeModalForStore(PreGameModal);
      this.showModal();
    },
  },
  computed: {
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseSuccessful.vue